module.exports = __webpack_public_path__ + "static/mosa-037a620706e9929df751e05826fbf502.pdf";